import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { activitiesQueryOptions } from '@/core/components/sites/site/activities-and-products/activitiesQueryOptions'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const activitiesSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z
    .enum(['id', 'shortTitle', 'price', 'maxAttendee', 'status', 'orderIndex'])
    .catch('shortTitle'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
})

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/activities-and-products/'
)({
  validateSearch: (search) => activitiesSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
    const activities = queryClient.ensureQueryData(
      activitiesQueryOptions(siteId, auth.token!)
    )
    return {
      activities,
    }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
